import { useEffect } from "react";
import Utils from "./Utils";

export function RegisterGlobalFunction(): React.ReactNode {
  useEffect(() => {
    Object.assign(window, { whoAmI, setJwtToken });
  }, []);
  return undefined;
}

function setJwtToken(token: string) {
  document.cookie = `token=${token};max-age=${86400 * 30}`;
}

function whoAmI() {
  const token = Utils.getCookie("token");
  return {
    token,
    payload: parseJwt(token),
  };
}

function parseJwt(token: string) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return e;
  }
}
